import { take, takeUntil } from 'rxjs/operators';
import { MappingAction, MappingMode } from '../../../shared/enum/mapping-mode.enum';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { UserApi } from '../../../api';
import { ExtraFilteringOptions, LoadOptions } from '../../../shared/models/shared.model';
import { GridSetting, GridSettings, GridState, User } from '../../../shared';
import { Subject } from 'rxjs';
import { CompanyDataService } from '../../../api/company-data.service';
import { CompanyLevelStateModel, CompanyMappingOption } from '../../../shared/models/company-data.model';
import { FilterBuilderService } from '../../../service/filter-builder.service';
import { LoaderService } from '../../../core/loader/loader.service';
import CustomStore from 'devextreme/data/custom_store';
import { NotificationService } from '../../../service/notification.service';
import { NotificationType } from '../../../shared/enum/notification.enum';

@Component({
  selector: 'app-company-mapping',
  templateUrl: 'company-mapping.component.html',
})
export class CompanyMappingComponent implements OnInit, OnDestroy {
  @ViewChild('companyMappingDataGrid') companyMappingDataGrid: DxDataGridComponent;
  @ViewChild('companyMasterDataGrid') companyMasterDataGrid: DxDataGridComponent;

  public companyMappingDataSource = {};
  public companyMasterDataSource = {};

  public companyMappingSelectedRowMap: any;
  public companyMasterSelectedRowMap: any;
  public extraFilteringOptions: ExtraFilteringOptions[] = [
	{ column: 'Active', value: false },
  ];
  public extraMasterFilteringOptions: ExtraFilteringOptions[] = [
	{ column: 'Active', value: false },
  ];

  public currentUser: User;

  public searchText;

  dataProviderCodeHeaderDataSource;
  companyNamedHeaderDataSource;
  totalCountHeaderDataSource;
  newHeaderDataSource;
  mapHeaderDataSource;
  saveHeaderDataSource;
  omitHeaderDataSource;
  inconsistencyHeaderDataSource;
  companyIdHeaderDataSource;
  masterBrandNameHeaderDataSource;
  brandNameHeaderDataSource;
  subBrandNameHeaderDataSource;
  createdByHeaderDataSource;
  createdOnHeaderDataSource;
  modifiedByHeaderDataSource;
  reviewedByHeaderDataSource;
  reviewedOnHeaderDataSource;

  brandingLevelHeaderDataSource;
  sourceCompanyHeaderDataSource;
  masterTableMasterBrandNameHeaderDataSource;
  masterTableBrandNameHeaderDataSource;
  masterTableSubBrandNameHeaderDataSource;

  mappingModeHeaderDataSource;
  modifiedOnHeaderDataSource;
  productBrandingLevelIdHeaderDataSource: any;
  productBrandingLevelNameHeaderDataSource: any;
  productMasterEntityIdNameHeaderDataSource: any;
  companyNameHeaderDataSource: any;
  mappingDataGridCurrentPage: number;
  private _destroyed$ = new Subject();
  private isCompanyMappingDataLoading: boolean;
  private isCompanyMasterDataLoading: boolean;

  public isLoadCompanyMappingGridDataSource: boolean;
  public isLoadCompanyMasterGridDataSource: boolean;
  private readonly mappingGridName: string = 'companyMappingDataGrid';
  private readonly masterGridName: string = 'companyMasterDataGrid';
  private readonly pageName: string = 'companyMapping';
  private currentCompanyMappingDataGridState: GridState;
  private currentCompanyMasterDataGridState: GridState;
  private companyMappingDataGridSettings: GridSettings;
  private companyMasterDataGridSettings: GridSettings;
  private isCompanyMappingDataGridSettingLoading = true;
  private isCompanyMasterDataGridSettingLoading = true;
  private companyMappingDataGridSetting: GridSetting = new GridSetting();
  private companyMasterDataGridSetting: GridSetting = new GridSetting();

  constructor(
	private companyDataService: CompanyDataService,
	private userService: UserApi,
	private filterBuilder: FilterBuilderService,
	private loaderService: LoaderService,
	private notificationService: NotificationService
  ) { }

  ngOnInit() {
	this.loaderService.show();
	this.currentUser = this.userService.logonUser;
	if (!this.currentUser) {
		return;
	}
	this.companyMappingDataGridSettings = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridSettings(this.companyMappingDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.companyMappingDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.companyMappingDataGridSetting = settings.Settings;
			}
		} else {
			this.companyMappingDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.companyMappingDataGridSettings);
		}
		this.loadCompanyMappingDataGridState();
		});

	this.companyMasterDataGridSettings = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};

	this.userService.getGridSettings(this.companyMasterDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.companyMasterDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.companyMasterDataGridSetting = settings.Settings;
			}
		} else {
			this.companyMasterDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.companyMasterDataGridSettings);
		}
		this.loadCompanyMasterDataGridState();
		});

	this.loadColumnHeaderFilterData();
  }

  private loadCompanyMappingDataSource() {
	this.isCompanyMappingDataGridSettingLoading = false;
	this.companyMappingDataSource = new CustomStore({
		key: 'CompanyMappingId',
		load: (loadOptions: any) => {
		this.isCompanyMappingDataLoading = true;
		this.loaderService.show();
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;
		finalOptions.extraParams = this.extraFilteringOptions;

		return this.companyDataService.getCompanyMappingGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isCompanyMappingDataLoading = false;
			this.loaderHandler();
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isCompanyMappingDataLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		}
	});
	this.isLoadCompanyMappingGridDataSource = true;
  }

  private loadCompanyMappingDataGridState() {
	const companyMappingDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(companyMappingDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentCompanyMappingDataGridState = state;
		} else {
			this.currentCompanyMappingDataGridState = {
			PageName: this.pageName,
			GridName: this.mappingGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadCompanyMappingDataSource();
		});
  }

  public loadMappingState = () => {
	return this.currentCompanyMappingDataGridState.State ? JSON.parse(this.currentCompanyMappingDataGridState.State) : null;
  }

  public saveMappingState = (state) => {
	if (this.companyMappingDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.companyMappingDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.companyMappingDataGridSetting);
		} else {
		gridSetting = this.companyMappingDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentCompanyMappingDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentCompanyMappingDataGridState);
		}
	}
  }

  private loadCompanyMasterDataSource() {
	this.isCompanyMasterDataGridSettingLoading = false;
	this.companyMasterDataSource = new CustomStore({
		key: 'RowId',
		load: (loadOptions: any) => {
		this.isCompanyMasterDataLoading = true;
		this.loaderService.show();
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;
		finalOptions.extraParams = this.extraMasterFilteringOptions;

		return this.companyDataService.getBrandingLevelMasterGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isCompanyMasterDataLoading = false;
			this.loaderHandler();
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isCompanyMasterDataLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		}
	});
	this.isLoadCompanyMasterGridDataSource = true;
  }

  private loadCompanyMasterDataGridState() {
	const companyMasterDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(companyMasterDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentCompanyMasterDataGridState = state;
		} else {
			this.currentCompanyMasterDataGridState = {
			PageName: this.pageName,
			GridName: this.masterGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadCompanyMasterDataSource();
		});
  }

  public loadMasterState = () => {
	return this.currentCompanyMasterDataGridState.State ? JSON.parse(this.currentCompanyMasterDataGridState.State) : null;
  }

  public saveMasterState = (state) => {
	if (this.companyMasterDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.companyMasterDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.companyMasterDataGridSetting);
		} else {
		gridSetting = this.companyMasterDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentCompanyMasterDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentCompanyMasterDataGridState);
		}
	}
  }

  private updateGridSettings(gridSettings: GridSettings) {
	gridSettings.SavedOn = new Date();
	this.userService.setGridSettings(gridSettings).pipe(take(1)).subscribe();
  }

  private updateGridState(gridState: GridState) {
	gridState.SavedOn = new Date();
	this.userService.setGridState(gridState).pipe(take(1)).subscribe();
  }

  private loadColumnHeaderFilterData() {
	this.dataProviderCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'DataProviderCode';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.companyNamedHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourceCompany';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.mappingModeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MappingModeName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.totalCountHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'TotalCount';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.newHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'NewCount';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.mapHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MapCount';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.saveHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SaveCount';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.omitHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'OmitCount';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.inconsistencyHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'IsInconsistentMappingMessage';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.companyIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CompanyId';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.productBrandingLevelIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ProductBrandingLevelId';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.productBrandingLevelNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ProductBrandingLevelName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.productMasterEntityIdNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ProductMasterEntityId';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.companyNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CompanyName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.masterBrandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MasterBrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.brandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'BrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.subBrandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SubBrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.createdByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.createdOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.modifiedByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.modifiedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.reviewedByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.reviewedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMapping(loadOptions);
		}
	});

	this.brandingLevelHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ProductBrandingLevelName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMaster(loadOptions);
		}
	});

	this.sourceCompanyHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CompanyName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMaster(loadOptions);
		}
	});

	this.masterTableMasterBrandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MasterBrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMaster(loadOptions);
		}
	});

	this.masterTableBrandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'BrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMaster(loadOptions);
		}
	});

	this.masterTableSubBrandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SubBrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMaster(loadOptions);
		}
	});
  }

  getHeaderFiltersCompanyMapping(loadingOption) {
	return this.companyDataService.getHeaderFiltersCompanyMapping(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  getHeaderFiltersCompanyMaster(loadingOption) {
	return this.companyDataService.getHeaderFiltersCompanyMaster(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  selectionMappingDataChangedHandler() {
	if (this.companyMappingDataGrid.instance.getSelectedRowsData()[0]) {
		this.companyMappingSelectedRowMap = this.companyMappingDataGrid.instance.getSelectedRowsData()[0];
	}
  }

  customizeCompanyMappingId(cellInfo) {
	const idStr = 'CmMp_000000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  customizeCompanyMasterId(cellInfo) {
	const idStr = 'CmMs_000000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  /**
   * Context menu for company mapping data grid
   * @param event
   */
   companyMappingDataGridContextMenu(e) {
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshCompanyMappingDataGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.companyMappingDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.companyMappingDataGridSetting.autosave = !this.companyMappingDataGridSetting.autosave;
				this.companyMappingDataGridSettings.Settings = JSON.stringify(this.companyMappingDataGridSetting);
				this.updateGridSettings(this.companyMappingDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  extraFilteringOptionsChange(columnName, event) {
	if (event) {
		const option = this.extraFilteringOptions.find(item => item.column === columnName);
		option.value = event.value;
		this.companyMappingDataGrid.instance.deselectAll();
		this.refreshCompanyMappingDataGrid();
	}
  }

  refreshCompanyMappingDataGrid() {
	this.mappingDataGridCurrentPage = this.companyMappingDataGrid.instance.pageIndex();
	this.companyMappingDataGrid.instance.refresh();
  }

  selectionMasterDataChangedHandler() {
	if (this.companyMasterDataGrid.instance.getSelectedRowsData()[0]) {
		this.companyMasterSelectedRowMap = this.companyMasterDataGrid.instance.getSelectedRowsData()[0];
	}
  }

  /**
   * Context menu for company master data grid
   * @param event
   */
   companyMasterDataGridContextMenu(e) {
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshcompanyMasterDataGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.companyMasterDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.companyMasterDataGridSetting.autosave = !this.companyMasterDataGridSetting.autosave;
				this.companyMasterDataGridSettings.Settings = JSON.stringify(this.companyMasterDataGridSetting);
				this.updateGridSettings(this.companyMasterDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  refreshcompanyMasterDataGrid() {
	this.companyMasterDataGrid.instance.refresh();
  }

  onReady(e) {
	const grid = e.component;
	const selection = grid.getSelectedRowKeys();
	if (this.companyMappingSelectedRowMap) {
		const currentDataItems = this.companyMappingDataGrid.instance.getDataSource().items();
		const isSelectedRowExists = currentDataItems.find(item =>
		item.CompanyMappingId ===
		this.companyMappingSelectedRowMap.CompanyMappingId
		);
		if (currentDataItems.length === 0 || !isSelectedRowExists) {
		this.companyMappingSelectedRowMap = {};
		}
		if (!isSelectedRowExists) {
		grid.selectRowsByIndexes([0]);
		}
	}
	if (selection.length === 0) {
		grid.selectRowsByIndexes([0]);
	}
  }

  onReadyMasterGrid(e) {
	const grid = e.component;
	const selection = grid.getSelectedRowKeys();
	if (selection.length === 0) {
		grid.selectRowsByIndexes([0]);
	}
  }

  formatFilterOperators(rawFilter: any[]) {
	if (!rawFilter) {
		return null;
	}
	const filterData = this.filterBuilder.handleNotFilterFormatting(rawFilter);
	return this.filterBuilder.filterFormatting(filterData);
  }

  // actions
  omit(companyMappingId) {
	const mappingData: CompanyMappingOption = {};
	mappingData.MappingModeId = MappingMode.Omitted;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.CompanyMappingId = companyMappingId;
	mappingData.ActionType = MappingAction.Omit;
	this.companyDataService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCompanyMappingDataGrid();
		});
  }

  save(companyMappingId) {
	const mappingData: CompanyMappingOption = {};
	mappingData.MappingModeId = MappingMode.Saved;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Save;
	mappingData.CompanyMappingId = companyMappingId;
	this.companyDataService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCompanyMappingDataGrid();
		});
  }

  deactivate(companyMappingId) {
	const mappingData: CompanyMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Deactivate;
	mappingData.CompanyMappingId = companyMappingId;
	this.companyDataService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCompanyMappingDataGrid();
		});
  }

  // accept(companyMappingId: any) {
  //   const mappingData: CompanyMappingOption = {};
  //   mappingData.ModifiedByUserId = this.currentUser.UserId;
  //   mappingData.ActionType = MappingAction.Accept;
  //   mappingData.CompanyMappingId = companyMappingId;
  //   this.companyDataService.mappingAction(mappingData)
  //     .pipe(takeUntil(this._destroyed$))
  //     .subscribe((res) => {
  //       this.refreshCompanyMappingDataGrid();
  //     });
  // }

  review(companyMappingId: any) {
	const mappingData: CompanyMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Review;
	mappingData.CompanyMappingId = companyMappingId;
	this.companyDataService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCompanyMappingDataGrid();
		});
  }

  reactivate(companyMappingId: any) {
	const mappingData: CompanyMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Reactivate;
	mappingData.CompanyMappingId = companyMappingId;
	this.companyDataService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCompanyMappingDataGrid();
		});
  }

  map(companyId, productBrandingLevelId, productMasterEntityId) {
	const mappingData: CompanyMappingOption = {};
	mappingData.MappingModeId = MappingMode.Mapped;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Map;
	mappingData.CompanyMappingId = this.companyMappingSelectedRowMap.CompanyMappingId;
	mappingData.ProductBrandingLevelId = productBrandingLevelId;
	mappingData.ProductMasterEntityId = productMasterEntityId;
	this.companyDataService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCompanyMappingDataGrid();
		});
  }

  private loaderHandler() {
	if (
		!this.isCompanyMappingDataLoading &&
		!this.isCompanyMasterDataLoading &&
		!this.isCompanyMappingDataGridSettingLoading &&
		!this.isCompanyMasterDataGridSettingLoading) {
		this.loaderService.hide();
	}
  }

  ngOnDestroy() {
	this.loaderService.hide();
	this._destroyed$.next(null);
	this._destroyed$.complete();
  }

  deactivateCompanyMaster(Id: any, ProductBrandingLevelId: any) {
	const data: CompanyLevelStateModel = {
		ProductBrandingLevelId,
		ModifiedByUserId: this.currentUser.UserId,
		Id
	};
	this.companyDataService.deactivateCompanyMaster(data)
		.pipe(take(1))
		.subscribe(res => {
		if (res) {
			this.notificationService.show('Deactivated successfully!', NotificationType.Success);
			this.refreshcompanyMasterDataGrid();
		} else {
			this.notificationService.show('Something went wrong', NotificationType.Error);
		}
		});
  }
}
